"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Coalesce = exports.IsNull = exports.Null = void 0;
var expression_1 = require("./expression");
var Null = /** @class */ (function (_super) {
    __extends(Null, _super);
    function Null(json) {
        return _super.call(this, json) || this;
    }
    Null.prototype.exec = function (_ctx) {
        return null;
    };
    return Null;
}(expression_1.Expression));
exports.Null = Null;
var IsNull = /** @class */ (function (_super) {
    __extends(IsNull, _super);
    function IsNull(json) {
        return _super.call(this, json) || this;
    }
    IsNull.prototype.exec = function (ctx) {
        return this.execArgs(ctx) == null;
    };
    return IsNull;
}(expression_1.Expression));
exports.IsNull = IsNull;
var Coalesce = /** @class */ (function (_super) {
    __extends(Coalesce, _super);
    function Coalesce(json) {
        return _super.call(this, json) || this;
    }
    Coalesce.prototype.exec = function (ctx) {
        if (this.args) {
            for (var _i = 0, _a = this.args; _i < _a.length; _i++) {
                var arg = _a[_i];
                var result = arg.execute(ctx);
                // if a single arg that's a list, coalesce over the list
                if (this.args.length === 1 && Array.isArray(result)) {
                    var item = result.find(function (item) { return item != null; });
                    if (item != null) {
                        return item;
                    }
                }
                else {
                    if (result != null) {
                        return result;
                    }
                }
            }
        }
        return null;
    };
    return Coalesce;
}(expression_1.Expression));
exports.Coalesce = Coalesce;
//# sourceMappingURL=nullological.js.map